module.exports = __webpack_public_path__ + "static/media/train_31.903f1f27.jpg";